import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import {
    asyncGetLabelParams,
    asyncGetParams,
} from '../../../../../services/param.service';
import { SamplesFilter } from '../../../../../shared/types/legalProceedings/samples';

export const useSamplesFilters = (onFilter?: (data: SamplesFilter) => void) => {
    const [status, setStatus] = useState<ISelect[]>([]);
    const [types, setTypes] = useState<ISelect[]>([]);
    const [areas, setAreas] = useState<ISelect[]>([]);
    const [inCharges, setInCharges] = useState<ISelect[]>([]);
    const [halfs, setHalfs] = useState<ISelect[]>([]);

    const onSubmit = (data: SamplesFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        if (formik?.values?.startCreatedAt) {
            formik?.setFieldValue('endCreatedAt', undefined);
        }
    }, [formik?.values?.startCreatedAt]);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.PQR_HALF).then((params) => {
            setHalfs(
                params
                    .filter(({ name }) => name !== 'Defensor DFC')
                    .map(({ id, name }) => ({ id, name }))
            );
        });
        asyncGetParams(ParamEnum.PQR_TYPE).then((params) => setTypes(params));
        asyncGetParams(ParamEnum.PQR_REDIRECTION_AREA).then((params) =>
            setAreas(params)
        );
        asyncGetParams(ParamEnum.INCHARGE).then((params) =>
            setInCharges(params)
        );
        asyncGetParams(ParamEnum.PQR_STATUS).then((params) =>
            setStatus(params)
        );
    }, []);

    return {
        formik,
        halfs,
        types,
        areas,
        inCharges,
        status,
    };
};
